/**
 * Where an exercise config form (`*.config.vue`) is being rendered.
 */
export type ExerciseConfigContext = "demo" | "regimen_view" | "regimen_edit" | "printable";

/** The known exercise config contexts. */
export const EXERCISE_CONFIG_CONTEXTS: readonly ExerciseConfigContext[] = [
  // The main exercise demo list, where an exercise is configured and tried out ad-hoc.
  "demo",
  // The launch step of a regimen exercise, where settings deliberately left out of the stored config (such as the reading text) are chosen.
  "regimen_view",
  // Editing the stored config of an exercise inside a regimen, preset or assignment.
  "regimen_edit",
  // Rendering the config as a printable sheet.
  "printable",
];

/** The context assumed when a config form is rendered without an explicit one. */
export const DEFAULT_EXERCISE_CONFIG_CONTEXT: ExerciseConfigContext = "demo";

/** True when `value` is one of the known exercise config contexts. */
export function isExerciseConfigContext(value: unknown): value is ExerciseConfigContext {
  return typeof value === "string" && (EXERCISE_CONFIG_CONTEXTS as readonly string[]).includes(value);
}
